<template>
    <component :is="component" v-if="component" :competitionData="competitionData"/>
</template>

<script>
    export default {
        name: "CompetitionWriteLink",
        mixins: [],
        components: {},
        provide() {
            return {}
        },
        props: {
            writeLayout: {},
            competitionData: {
                type: Object,
                default: () => {
                    return {}
                }
            },
        },
        data() {
            return {
                component: null,
            }
        },
        created() {},
        mounted() {
            this.writeLoader()
        },
        beforeDestroy() {},
        destroyed() {},
        computed: {
            loader() {
                if (!this.writeLayout) {
                    return null
                }
                return () => import(`@/template/competition/write/${this.writeLayout}`)
            },
        },
        methods: {
            writeLoader() {
                this.loader()
                    .then(() => {
                        this.component = () => this.loader()
                    })
                    .catch(() => {
                        this.component = () => import('@/template/competition/write/CompetitionWriteDefaultLayout')
                    })
            }
        },
        watch: {},
    }
</script>

<style scoped>

</style>
